import { StyleSheet } from 'react-native-web';

/*
  credit:
  https://bootcamp.uxdesign.cc/creating-a-clean-responsive-design-system-for-react-native-web-and-mobile-2d609a0cc23e
*/

const CreateResponsiveStyle = (webStyles = {}, mobileStyles = {}) => {
  const web = StyleSheet.create(webStyles);
  const mobile = StyleSheet.create(mobileStyles);

  return (layout, breakpoint) => style => {
    if (!breakpoint) {
      return web[style];
    }
    if (layout.width < breakpoint) {
      return StyleSheet.compose(web[style], mobile[style]);
    }
    return web[style];
  };
};

export default CreateResponsiveStyle;
